import styled, { css } from 'styled-components';

const PriceLineThrough = styled.div`
  text-decoration: line-through;
  ${({ desktopMode, theme }) =>
    desktopMode
      ? css`
          ${theme.fontFamily.secondaryFont.xSmallRegular};
          color: ${theme.colors.white};
        `
      : css`
          ${theme.fontFamily.secondaryFont.xSmallBold};
          span {
            color: ${theme.colors.night_blue_3};
          }
        `}
`;

export default PriceLineThrough;
